function getFocusables(element: HTMLElement) {
    return [...element.querySelectorAll<HTMLElement>(
        'a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
    )].filter(el => !el.hasAttribute('disabled'))
}

export function AcquireFirstFocus(container: HTMLElement|null) {
    if (!container) return;

    const focusables = getFocusables(container)
    if (focusables.length === 0) return;

    focusables[0].focus();
}

export function AcquireLastFocus(container: HTMLElement|null) {
    if (!container) return;

    const focusables = getFocusables(container)
    if (focusables.length === 0) return;

    focusables[focusables.length - 1].focus();
}

export function AcquireNextFocus(container: HTMLElement|null, focused: HTMLElement, selector: string = '*') {
    if (!container) return

    const list = getFocusables(container).filter(el => {
        return el.matches(selector)
    })

    const index = list.indexOf(focused)
    if (index === list.length - 1) {
        // loop over
        list[0].focus()
    } else {
        // find next
        list[index + 1].focus()
    }
}

export function AcquirePreviousFocus(container: HTMLElement|null, focused: HTMLElement, selector: string = '*') {
    if (!container) return

    const list = getFocusables(container).filter(el => {
        return el.matches(selector)
    })

    const index = list.indexOf(focused)
    if (index === 0) {
        // loop over
        list[list.length - 1].focus()
    } else {
        // find next
        list[index - 1].focus()
    }
}
